import AboutUs from './pages/aboutus/AboutUs.vue';
import ContactUs from './pages/contactus/ContactUs.vue';
import News from './pages/news/News.vue';
import Image from './pages/image/Image.vue';
import VendorPrice from './pages/price/VendorPrice.vue';
import FormexPrice from './pages/formex/FormexPrice.vue';
import FormexSubscriptionForm from './pages/formex/FormexSubscriptionForm.vue';
import Home from './pages/home/Home.vue';
import ResetPassword from './pages/resetpassword/ResetPassword.vue';
import Dashboard from './pages/vendors/DashboardComponent.vue';
import UploadForm from './pages/vendors/UploadFormComponent.vue';
import List from './pages/vendors/ListComponent.vue';

import { useUserStore } from './stores/UserStore';

const companyRouteGuard = (to, from, next) => {
    const userStore = useUserStore();

    if (userStore.isAuthenticatedVendor) {
        next();
        return;
    }
    next('/');
};

export const routes = [
    // public routes
    { path: '/', component: Home, name: 'Home', meta: { headerTheme: 'light' }},
    { path: '/aboutus', component: AboutUs, name: 'AboutUs' },
    { path: '/contactus', component: ContactUs, name: 'ContactUs' },
    { path: '/price', component: VendorPrice, name: 'VendorPrice', meta: { headerTheme: 'light' }},
    { path: '/formex', component: FormexPrice, name: 'FormexPrice', meta: { headerTheme: 'light' }},
    { path: '/formexform', component: FormexSubscriptionForm, name: 'FormexSubscriptionForm', meta: { headerTheme: 'light' }, props: (route) => ({ subscription: route.query.subscription }) },
    { path: '/resetpassword', component: ResetPassword, name: 'ResetPassword', meta: { headerTheme: 'light' }, props: (route) => ({ resetpasswordkey: route.query.key }) },
    { path: '/companyselect', component: Home, name: 'CompanySelect', meta: { headerTheme: 'light' }, props: (route) => ({ selectcompany: true }) },
    // { path: '/news/en/:slug', component: News, name: 'EnglishNews' },
    { path: '/news/:slug', component: News, name: 'News' },
    { path: '/image/:id', component: Image, name: 'Image' },
    { path: '/company/:slug', component: Home, name: 'Company', meta: { headerTheme: 'light' }, props: (route) => ({ companysearchbyurl: route.params.slug, maincategoryqueryparam: route.query.maincategory }) },

    // vendor/company routes
    { 
        path: '/vendors/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        beforeEnter: companyRouteGuard
    },
    { 
        path: '/vendors/upload',
        name: 'Upload',
        component: UploadForm,
        beforeEnter: companyRouteGuard
    },
    { 
        path: '/vendors/list',
        name: 'List',
        component: List,
        beforeEnter: companyRouteGuard
    }
];
